import * as React from "react";

interface IProps{
    even?: false | true;
    img: string;
    title: React.ReactNode;
    content: string;
}
export default class HowItWorksItem extends React.Component<IProps, any> {
    constructor(props: IProps){
        super(props);
    }
    render(){
        return (
            <div className="HowItWorksItem">
                <div className="container">
                    <div className="row">
                        <div className={`col-sm-6 HowItWorksItem__image ${this.props.even?'col-sm-push-6 reverse text-left':'text-right'}`}>
                            <img className='console' src={`assets/images/courses/${this.props.img}`} alt={this.props.img} />
                        </div>
                        <div className={`col-sm-6 HowItWorksItem__describe ${this.props.even?'col-sm-pull-6 reverse text-right':'text-left'}`}>
                            <div className="inner">
                                <p className='title'>{this.props.title}</p>
                                <span className='line'></span>
                                <p className='content'>{this.props.content}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/homepage/HowItWorksItem.tsx